import axios from 'axios'

class OddsRepository {
  getLive (sport) {
    return axios.get(`${BASE_URL}/odds/live/${sport || ''}`, {params: {offset: new Date().getTimezoneOffset() / 60}})
    .then(response => {
      return response.data
    })
    .catch(error => console.log(error))
  }

  getUpcoming(sport) {
    console.log(sport)
    return axios.get(`${BASE_URL}/odds/upcoming/${sport || ''}`, {params: { offset: new Date().getTimezoneOffset() / 60}})
    .then(response => {
      return response.data
    })
    .catch(error => console.log(error))
  }

  getRecent(sport) {
    console.log(sport)
    return axios.get(`${BASE_URL}/odds/upcoming/${sport || ''}`, {params: { offset: new Date().getTimezoneOffset() / 60}})
    .then(response => {
      return response.data
    })
    .catch(error => console.log(error))
  }

  getForSport (sport) {
    return axios.get(`${ODDS_URL}/odds/${sport}`)
    .then(response => {
      return response.data
    })
    .catch(error => console.log(error))
  }

}

export default new OddsRepository()



// WEBPACK FOOTER //
// ./src/data/odds.repository.js